import React from 'react';

function ProductRecommendations({ faceShape, skinTone }) {
  const AMAZON_ID = 'vikash071109-21';
  
  const products = {
    styling: [
      {
        name: "Moroccanoil Treatment Original",
        category: "Styling Oil",
        price: "$44",
        link: `https://www.amazon.com/dp/B001AO0WCG?tag=${AMAZON_ID}`,
        bestFor: ["Oval", "Square", "Heart", "Diamond"],
        image: "🧴",
        description: "Nourishing oil for all hair types"
      },
      {
        name: "Dyson Airwrap Multi-styler",
        category: "Hot Tools",
        price: "$599",
        link: `https://www.amazon.com/dp/B0B3CJSXXW?tag=${AMAZON_ID}`,
        bestFor: ["All shapes"],
        image: "💨",
        description: "Professional styling with less heat damage"
      },
      {
        name: "Oribe Dry Texturizing Spray",
        category: "Volume & Texture",
        price: "$49",
        link: `https://www.amazon.com/dp/B003NXM9QC?tag=${AMAZON_ID}`,
        bestFor: ["Round", "Oblong", "Rectangle"],
        image: "✨",
        description: "Adds instant volume and grip"
      },
      {
        name: "Ghd Platinum+ Styler",
        category: "Flat Iron",
        price: "$279",
        link: `https://www.amazon.com/dp/B07CM53DBZ?tag=${AMAZON_ID}`,
        bestFor: ["Square", "Triangle", "Diamond"],
        image: "🔥",
        description: "Smart styler for precise results"
      }
    ],
    color: [
      {
        name: "Madison Reed Root Touch Up",
        category: "At-home Color",
        price: "$30",
        link: `https://www.amazon.com/s?k=Madison+Reed+Root+Touch+Up&tag=${AMAZON_ID}`,
        bestFor: ["Warm", "Neutral"],
        image: "🎨",
        description: "Ammonia-free, salon-quality color"
      },
      {
        name: "Clairol Nice'n Easy",
        category: "Permanent Color",
        price: "$8",
        link: `https://www.amazon.com/s?k=Clairol+Nice+n+Easy&tag=${AMAZON_ID}`,
        bestFor: ["Cool", "Neutral", "Warm"],
        image: "💇",
        description: "Budget-friendly with natural results"
      }
    ],
    care: [
      {
        name: "Biolage Color Last Shampoo",
        category: "Color Care",
        price: "$20",
        link: `https://www.amazon.com/dp/B00ILB9E6C?tag=${AMAZON_ID}`,
        bestFor: ["All"],
        image: "🧼",
        description: "Preserves color-treated hair"
      }
    ],
    browseAll: [
      {
        name: "Browse All Hair Care Products",
        category: "Amazon Best Sellers",
        price: "Explore Deals",
        link: `https://www.amazon.com/s?k=hair+care&tag=${AMAZON_ID}`,
        bestFor: ["All"],
        image: "🛍️",
        description: "Discover top-rated hair products"
      },
      {
        name: "Shop Beauty & Personal Care",
        category: "Amazon Beauty",
        price: "See All Deals",
        link: `https://www.amazon.com/beauty?tag=${AMAZON_ID}`,
        bestFor: ["All"],
        image: "💄",
        description: "Makeup, skincare, and more"
      }
    ],
    services: [
      {
        name: "Find a Stylist Near You",
        category: "Professional Service",
        price: "Book Now",
        link: "https://www.styleseat.com",
        bestFor: ["All"],
        image: "✂️",
        cta: "Search Stylists",
        description: "Book top-rated hair professionals"
      }
    ]
  };

  const relevantProducts = [
    ...products.styling.filter(p => p.bestFor.includes(faceShape) || p.bestFor.includes("All shapes")),
    ...products.color.filter(p => p.bestFor.includes(skinTone) || p.bestFor.includes("All")),
    ...products.care.slice(0, 1),
    ...products.browseAll,
    ...products.services
  ];

  return (
    <div className="product-recommendations">
      <h3>🛒 Recommended Products for Your {faceShape} Shape</h3>
      <p className="affiliate-note">Handpicked products to achieve your recommended styles • Affiliate links</p>
      
      <div className="product-grid">
        {relevantProducts.map((product, idx) => (
          <a 
            key={idx} 
            href={product.link} 
            className="product-card"
            target="_blank"
            rel="noopener noreferrer sponsored"
          >
            <div className="product-icon">{product.image}</div>
            <div className="product-info">
              <div className="product-category">{product.category}</div>
              <div className="product-name">{product.name}</div>
              <div className="product-description" style={{fontSize: '0.85rem', color: '#666', margin: '5px 0'}}>
                {product.description}
              </div>
              <div className="product-price">{product.price}</div>
            </div>
            <div className="product-cta">
              {product.cta || "View on Amazon →"}
            </div>
          </a>
        ))}
      </div>

      <div className="salon-finder">
        <h4>Ready for a Professional Transformation?</h4>
        <p>Find stylists who specialize in {faceShape.toLowerCase()} face shapes and {skinTone.toLowerCase()} undertones</p>
        <a 
          href="https://www.styleseat.com" 
          className="btn-salon" 
          target="_blank" 
          rel="noopener noreferrer sponsored"
        >
          Find Stylists Near Me
        </a>
      </div>
    </div>
  );
}

export default ProductRecommendations;